import $ from 'jquery';
import Dialog from '@/lib/dialog.js';

/**
 * Deleter Class
 *
 * Performs a delete action with ajax.
 */
export default function (container) {
	const debug = false;
	container = $(container);

	container.find('.deleter-action').on('click', function (e) {
		e.preventDefault();

		const route = $(this).parent().prev('input[name="route"]').val();

		const dialog = new Dialog();

		dialog.show({ content: $('#lang-strings #alerts-delete-item').text() }, function () {
			$.ajax({
				type: 'DELETE',
				url: route,
				data: 'DELETE',
				dataType: 'json',
				timeout: 10000,
			})
				.done(function (response) {
					if (debug) {
						// eslint-disable-next-line no-console
						console.log(response);
					}

					if (response.redirect) {
						window.location.href = response.redirect;
					}
				})
				.fail(function (response) {
					if (debug) {
						// eslint-disable-next-line no-console
						console.log(response);
					}
				});
		});
	});
}
